/* eslint-disable react/prefer-stateless-function */
import React, { useState, useMemo } from "react";
import PropTypes from "prop-types";
import StripPlot from "./StripPlot";
import { formatComma } from "../utils/dataHelpers/formatters";
import { TOOLTIP_SCHEMA } from "../utils/constants";
import Dropdown from "./Dropdown";
import Summary from "./Summary";
import Heading from "./Heading";

const DEFAULT_SELECT_COUNTY = {
  value: undefined,
  label: "",
};

const Body = ({ data }) => {
  const { multiGroup, countyClasses } = data;
  const [selectCounty, setSelectCounty] = useState(DEFAULT_SELECT_COUNTY);
  const [selectGroup, setSelectGroup] = useState("2-A");
  const handleSelectionChange = (newSelection) => {
    if (!newSelection) {
      return;
    }
    const { class: selectedCountyClass } = countyClasses.find(
      (datum) => datum.id === newSelection.value
    );
    setSelectGroup(selectedCountyClass);
    setSelectCounty(newSelection);
  };

  // process groups
  const { multiSeries, meanClassWorkload } = useMemo(() => {
    return multiGroup.find((group) => group.label === selectGroup);
  }, [multiGroup, selectGroup]);

  return (
    <div className="body__container">
      <Dropdown
        handleChange={handleSelectionChange}
        options={countyClasses}
        selection={selectCounty}
      />
      <Heading countyClass={selectGroup} />
      <StripPlot
        data={multiSeries}
        xAxisKey="workload"
        xAxisTickFormatter={formatComma}
        xAxisLabel="Workload score"
        xAxisHeight={55}
        yAxisWidth={139}
        tooltipSchema={TOOLTIP_SCHEMA}
        multiSeriesMean={meanClassWorkload}
      />
      <Summary selectGroup={selectGroup} data={multiSeries} />
    </div>
  );
};

Body.propTypes = {
  data: PropTypes.shape({
    multiGroup: PropTypes.arrayOf(PropTypes.any),
    countyClasses: PropTypes.arrayOf(PropTypes.any),
  }).isRequired,
};

export default Body;
